import { render, staticRenderFns } from "./Searchs.vue?vue&type=template&id=00a71f8e&scoped=true&"
import script from "./Searchs.vue?vue&type=script&lang=js&"
export * from "./Searchs.vue?vue&type=script&lang=js&"
import style0 from "./Searchs.vue?vue&type=style&index=0&id=00a71f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a71f8e",
  null
  
)

export default component.exports